/**
 *
 * state状态
 * @typedef {Object} generateState
 * @description 生图模块使用的redux state
 */

const Generate = {
  state: {
    openList:[], //打开的提示框列表 CYCD-创意程度 MXXZ-模型选择 STFG-生图风格 FGCKTSZ-风格参考图设置 

    referenceImg:null, //参考图
    referenceImgSize:{width:1200,height:600},//参考图尺寸
    imgSource: '',
    scene:0, //识图的场景 0-室内 1-室外
    specificTheme: '',
    creativeType:1, //创意程度 0-精准还原 1-局部还原 2-灵感发散 3-自由创造
    quickWordId:null, //快速参考词id
    modelList:[], //绘画模型list
    modelId:null, //绘画模型id,后端参数叫 theme_id
    modelName:'', //模型名称
    styleId:null, //生图风格id
    styleObj:null, //生图风格obj,存放选中的生图风格的信息
    styleInfoList:[],  //和模型联动的生图风格list

    styleReferenceImg:'', //风格参考图
    styleReferenceImgSize:{width:1200,height:600}, //风格参考图尺寸
    styleReferenceType:1, //风格参考图-参考内容 1-风格 2-主体 3-材质
    styleImgSimilar:1, //风格参考图-创意程度 0~1

    positiveDesc:'', //描述词
    useIntellectPrompt: 1, // 是否开启ai优化描述词 0-否 1-是
    imageTypeId:null ,//图片类型ID 0-效果图 1-线稿图 2-白模图
    autoStart: false,
    aspectRatio: '1:1', //宽高比
  },
  reducers: {
    /**
     * @description 更新state
     * @param state: 当前state
     * @param payload: 更新state对象
     */
    updateState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    setModelId(data) {
      this.updateState({
        modelId: data,
      });
    },
    setModelName(data) {
      this.updateState({
        modelName: data,
      });
    },
    setStyleInfoList(data) {
      this.updateState({
        styleInfoList: data,
      });
    },
    setStyleId(data) {
      this.updateState({
        styleId: data,
      });
    },
    setCreativeType(data) {
      this.updateState({
        creativeType: data,
      });
    },
    setOpenList(data) {
      this.updateState({
        openList: data,
      });
    },
    setStyleObj(data) {
      this.updateState({
        styleObj: data,
      });
    },
    setStyleReferenceImg(data) {
      this.updateState({
        styleReferenceImg: data,
      });
    },
    setStyleReferenceType(data) {
      this.updateState({
        styleReferenceType: data,
      });
    },
    setStyleImgSimilar(data) {
      this.updateState({
        styleImgSimilar: data,
      });
    },
    setReferenceImg(data) {
      this.updateState({
        referenceImg: data,
      });
    },
    setReferenceImgSize(data) {
      this.updateState({
        referenceImgSize: data,
      });
    },
    setScene(data) {
      this.updateState({
        scene: data,
      });
    },
    setModelList(data) {
      this.updateState({
        modelList: data,
      });
    },
    setPositiveDesc(data) {
      this.updateState({
        positiveDesc: data,
      });
    },
    setStyleReferenceImgSize(data) {
      this.updateState({
        styleReferenceImgSize: data,
      });
    },
     setImageTypeId(data) {
      this.updateState({
        imageTypeId: data,
      });
    },
    setImgSource(data) {
      this.updateState({
        imgSource: data,
      });
    },
    setQuickWordId(data) {
      this.updateState({
        quickWordId: data,
      });
    },
    setSpecificTheme(data) {
      this.updateState({
        specificTheme: data,
      });
    },
    setAutoStart(data) {
      this.updateState({
        autoStart: data,
      });
    },
    setUseIntellectPrompt(data) {
      this.updateState({
        useIntellectPrompt: data,
      });
    },
    setAspectRatio(data) {
      this.updateState({
        aspectRatio: data,
      });
    }
  }),
};

export default Generate;
